/* eslint-disable */
import React, { useState, useRef } from 'react';
import { Tooltip } from 'react-tooltip';
import { LabelBubble } from './LabelBubble';
import { IncomeChartData } from '../../types/incomeChartData';
import { CategoriesItem } from '../../types/categoriesItem';
import { calculatePercentages, getColoredCategories } from '../../utils/insights.utils';
import { convertValueToUSD } from '../../../../helpers/currency.helper';

type HorizontalStackBarProps = {
  incomeChartData: IncomeChartData;
};

export const HorizontalStackBar = ({ incomeChartData }: HorizontalStackBarProps) => {
  const { categoriesItems } = incomeChartData || {};
  const [selectedItem, setSelectedItem] = useState<CategoriesItem | null>(categoriesItems?.[0] || null);
  const totalValue = categoriesItems?.reduce((total, item) => total + item.total, 0);
  const refs = useRef<any>([]);
  const handleLabelBubbleClick = (chartItem: CategoriesItem) => {
    setSelectedItem(chartItem);
    if (refs.current[chartItem.categoryId]) {
      refs.current[chartItem.categoryId]!.click(); // Use non-null assertion because we already check for null
    }
  };

  const handleStackBarClick = (chartItem: CategoriesItem) => {
    setSelectedItem(chartItem);
  };

  const categoriesWithPercentage = calculatePercentages(getColoredCategories(categoriesItems));
  return (
    <div className='mt-5 mb-[32px] flex flex-col justify-start'>
      <div className='h-[10px] bg-bw03 rounded-[27px] relative flex w-full'>
        {categoriesWithPercentage.map((item, index) => (
          <div
            key={item.categoryId}
            ref={(el) => (refs.current[item.categoryId] = el)}
            id={`tooltip-category-${item.categoryId}`}
            data-testid={`tooltip-category-${item.categoryId}`}
            onClick={() => handleStackBarClick(item)}
            className={`
            h-full z-20 
            transform 
            transition-transform 
            duration-200 ${index === 0 ? 'rounded-l-[27px]' : ''} ${index === categoriesItems.length - 1 ? 'rounded-r-[27px]' : ''}
            ${selectedItem?.title === item.title ? 'scale-y-110 shadow-2xl z-50' : ''}`}
            style={{
              width: `${(item.total / totalValue) * 100}%`,
              zIndex: `${selectedItem?.categoryId === item.categoryId ? 50 : 20}`,
              backgroundColor: item.color,
            }}
          >
            <Tooltip anchorSelect={`#tooltip-category-${item.categoryId}`} place='top' openOnClick>
              <div
                className='h-[19px] py-[7px] bg-bw08 text-bw00 flex rounded-[14px] items-center justify-center'
                data-testid={`tooltip-category-wrapper-${item.categoryId}`}
              >
                <div
                  className='font-metricRMedium text-[12px] text-bw00'
                  data-testid={`tooltip-category-${item.categoryId}__percentage`}
                >
                  {item.percentage}%
                </div>
                <span className='mx-[5px] text-bw04'>|</span>
                <div
                  className='font-metricRMedium text-[12px] text-bw00'
                  data-testid={`tooltip-category-${item.categoryId}__total`}
                >
                  {convertValueToUSD(item.total, 2)}
                </div>
              </div>
            </Tooltip>
          </div>
        ))}
      </div>
      <div className='flex flex-wrap mt-8 h-[70px]'>
        {categoriesWithPercentage.map((item) => (
          <div className='w-1/2' key={`label_${item.title}`}>
            <LabelBubble
              item={item}
              onItemClick={handleLabelBubbleClick}
              isActive={selectedItem?.title === item.title}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
